import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-passsenger-detail',
  templateUrl: './passsenger-detail.component.html',
  styleUrls: ['./passsenger-detail.component.css']
})
export class PasssengerDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
